export default {
      id: "gender-usage",
      viewBox: "0 0 81 83",
      url: __webpack_public_path__ + "sprite.svg#gender",
      toString: function () {
        return this.url;
      }
    }